import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link, Paper, Typography } from '@mui/material';

import { DocumentIcon, OpenLinkIcon } from '../../../components/common/Icon';
import { formatDate } from '../../../shared';

import {
  StyledAlreadyUploadedDocument,
  StyledAlreadyUploadedDocumentContainer,
  StyledAlreadyUploadedDocumentLinkContainer,
  StyledVerticalContent,
  StyledVerticalInnerContent,
} from './AlreadyUploadedDocuments.styled';

export default function AlreadyUploadedDocuments({ documentsAttachments }) {
  return (
    <Paper>
      <StyledVerticalContent>
        <Typography variant="h3">
          <FormattedMessage id="user_claims_info.already_uploaded_documents.title" />
        </Typography>

        <div>
          {Array.isArray(documentsAttachments) &&
            documentsAttachments.map((document) => (
              <StyledAlreadyUploadedDocumentContainer key={document?.filename}>
                <StyledAlreadyUploadedDocument>
                  <DocumentIcon />

                  <StyledVerticalInnerContent>
                    <Typography variant="p">{document?.filename}</Typography>

                    {document?.date && (
                      <Typography variant="p" color="product_blue">
                        <FormattedMessage id="user_claims_info.already_uploaded_documents.document_date_label" />
                        &nbsp;
                        {formatDate(document?.date)}
                      </Typography>
                    )}
                  </StyledVerticalInnerContent>
                </StyledAlreadyUploadedDocument>

                <StyledAlreadyUploadedDocumentLinkContainer>
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <Link
                    component="button"
                    variant="h3"
                    onClick={() => (document?.url ? window.open(document?.url, '_blank') : null)}
                  >
                    <FormattedMessage id="user_claims_info.already_uploaded_documents.document_open_link" />
                    <OpenLinkIcon />
                  </Link>
                </StyledAlreadyUploadedDocumentLinkContainer>
              </StyledAlreadyUploadedDocumentContainer>
            ))}
        </div>
      </StyledVerticalContent>
    </Paper>
  );
}
